import React from 'react';

const AboutSection = () => {
  return (
    <section id="nosotros" className="py-20 px-6 bg-cream">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_dulces-tradicionales/artifacts/7b8wf21u_01%20Manjar.jpg" 
              alt="Artisan Bakery" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="space-y-6">
            <h2 className="text-4xl font-bold text-chocolate">Tradición & Creatividad</h2>
            <p className="text-lg text-chocolate-light leading-relaxed">
              En Brazolovers, cada brazo gitano es una obra de arte comestible. Elaboramos nuestros productos 
              de forma fresca cada día, cuidando cada detalle para ofrecer una experiencia dulce única.
            </p>
            <p className="text-lg text-chocolate-light leading-relaxed">
              Con más de 40 sabores únicos, honramos la herencia del brazo gitano, un clásico de la repostería 
              española que conquistó Latinoamérica, añadiendo toques creativos e innovadores que sorprenden a cada bocado.
            </p>
            <div className="grid grid-cols-3 gap-6 pt-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-caramel">+40</div>
                <div className="text-sm text-chocolate-light">Sabores</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-caramel">100%</div>
                <div className="text-sm text-chocolate-light">Artesanal</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-caramel">Fresco</div>
                <div className="text-sm text-chocolate-light">Cada Día</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
